import React from 'react';
import { SectionPanel } from 'ui';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { ComplexValue } from 'app/types-shared';
import { MetroLineSection } from 'app/components/metro-line/metro-line-section';
import { ReportCode } from 'app/area/shared/report/report-code';
import { CompanyReportSectionType } from '../metroline/types';
import { userGroupCodetableId, CompanyReportFormIds } from '../constants';
import { endpoints } from '../endpoints';
import { CompanyReportSection } from '../types';

export const CompanyReportVisibility: React.FC<CompanyReportSection> = ({
  companyReportItem, updateItem, options, loadOptions,
  validation, translation, section, getRef, shouldRenderSection, locale
}) => {

  const onSubsetChange = (values: ComplexValue<number>[]) => {
    updateItem({ subset: values });
  };

  return <MetroLineSection<CompanyReportSectionType>
    section={section}
    sectionType={CompanyReportSectionType.Visibility}
    getRef={getRef}
    shouldRenderSection={shouldRenderSection}>
    <div ref={getRef(CompanyReportSectionType.Visibility)}>
      <SectionPanel
        className="admin-paper-top-panel"
        componentId={CompanyReportSectionType.Visibility}
        validation={undefined}
        info={{ text: translation.visibility }}
        label={{ visible: true, text: translation.visibility }} />
      <MainGridContainer>
        <div className="row">
          <div className="col-lg-6 col-sm-12">
            <ReportCode
              id={CompanyReportFormIds.subsetId}
              label={translation?.visible_for_user_groups}
              isHierarchy={true}
              values={companyReportItem?.subset}
              onChange={onSubsetChange}
              optionsEndpoint={endpoints.userGroupOptions}
              options={options?.[CompanyReportFormIds.subsetId]}
              loadOptions={loadOptions}
              validation={validation?.subset}
              searchLabel={translation?.search}
              manageOptionsId={userGroupCodetableId}
              manageOptionsLabel={translation.manage_options}
              locale={locale} />
          </div>
        </div>
      </MainGridContainer>
    </div>
  </MetroLineSection>;
};
